import { ACTION_CODE, ENTITY_TYPES_REQUEST, EVENT_CODE } from '@constants'
import { ActionJSScriptConfig, FormCommand, TimelineActionMeta } from '@types'

import { getTimelineCommandScriptConfig } from './getTimelineCommandScriptConfig'
import { getTimelineJSFieldScriptConfig } from './getTimelineJSFieldScriptConfig'

type Props = {
  type: ENTITY_TYPES_REQUEST
  eventCode?: EVENT_CODE | null
  actionCode?: ACTION_CODE
  command?: FormCommand[] | null
  meta?: TimelineActionMeta
}

export const getJSScriptConfig = (
  data: Props
): {
  jsField?: ActionJSScriptConfig
  command?: ActionJSScriptConfig
} => {
  const { type, eventCode, actionCode, command, meta } = data

  switch (type) {
    case ENTITY_TYPES_REQUEST.TIME_TABLE:
      return {
        jsField: getTimelineJSFieldScriptConfig({ eventCode, actionCode, command }),
        command: getTimelineCommandScriptConfig({ eventCode, actionCode, meta }),
      }
    default:
      return {
        jsField: undefined,
        command: undefined,
      }
  }
}
